import React from 'react';
import './PatientInfoPanel.css';
import { dateTimeFormatter } from '../../../CommonComponents/Utils/DateTimeFormatter';

const PatientVisitInformation = ({ patient}) => {
  return (
    <div className="panel-box">
      {/* <h3>Visit Information</h3> */}
      <div className="info-row">
        <span className="label">IP NUMBER</span>
        <span className="colon">:</span>
        <span>-</span>
      </div>
      <div className="info-row">
        <span className="label">Prescribed Doctor</span>
        <span className="colon">:</span>
        <span>{patient.doctorName}</span>
      </div>
      <div className="info-row">
        <span className="label">Request Time </span>
        <span className="colon">:</span>
        <span>{dateTimeFormatter(patient.prescriptionDate,patient.prescriptionTime)}</span>
      </div>
      
      {/* <p><strong>Booked Type:</strong> {patient.bookingType}</p>
      <p><strong>Booked Time:</strong> {patient.timeSlot}</p>
      <p><strong>Booked By:</strong> Reception</p>
      <p><strong>Hospital Reached Time:</strong> 10:00 AM</p>
      <p><strong>User Reached Time:</strong> 10:10 AM</p>
      <p><strong>Purpose of Visit:</strong> Consultation</p>
      <p><strong>Appointment No:</strong> {patient.appointmentId}</p>
      <p><strong>Casefile No:</strong> CF987654</p> */}
    </div>
  );
};

export default PatientVisitInformation;
